import {
  type ISpecGroup,
  type ISpecItem} from '../../types'
import {
  type PriceGroupCallback,
  type PriceSpecLimitation
} from './types'

/**
 *
 * @param val
 * @returns
 */
export function mapSpecLimitation (
  val: Record<string, string[]>
): PriceSpecLimitation[] {
  const arr: PriceSpecLimitation[] = []
  for (const key in val) {
    arr.push({
      name: key,
      values: val[key]
    })
  }
  return arr
}



/**
 * 获得可用的spec
 * @param options
 * @param spec
 * @param all
 * @returns
 */
export const getSelectedValue = (
  options: PriceGroupCallback,
  spec: ISpecGroup<ISpecItem>,
  all = false
): string[] => {
  const specName = spec.name
  let selectedValues = []

  const specLimitation = options.selectedItem!.specLimitation
  const findItem = specLimitation?.find((f) => f.name === specName)
  if (!findItem) return spec.values.filter(f=>f.value!=='-1').map((f: any) => f.value);
  if (
    specLimitation &&
    specLimitation.findIndex((f) => f.name === specName) !== -1
  ) {
    if (
      ['productSpec', 'spec', 'addon'].includes(options.type) &&
      specName === options.value.name
    ) {
      if (
        findItem?.values.some(function (it) {
          return it === options.value.value
        })
      ) {
        selectedValues.push(options.value.value)
      } else {
        selectedValues = findItem?.values ?? []
      }
    } else {
      selectedValues = findItem.values
    }
  } else {
    if (
      ['productSpec', 'spec', 'addon'].includes(options.type) &&
      specName === options.value.name
    ) {
      selectedValues.push(options.value.value)
    } else {
      spec.values.some((it: any) => {
        if (it.value !== '-1') {
          selectedValues.push(it.value)
          return !all
        }
        return false
      })
    }
  }
  return selectedValues.filter(f=>f!=='-1');
}
